import { render, staticRenderFns } from "./PizzaChartAnswered.vue?vue&type=template&id=6547b16a"
import script from "./PizzaChartAnswered.vue?vue&type=script&lang=js"
export * from "./PizzaChartAnswered.vue?vue&type=script&lang=js"
import style0 from "./PizzaChartAnswered.vue?vue&type=style&index=0&id=6547b16a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports